import {
  Encounter,
  ENCOUNTERS,
  getPracticeUsersCollectionPath,
  INVOICES,
  practiceAdminRoles,
  PracticeInvoice,
  PracticeUserRoleItem,
} from '@hb/shared'
import { collection, Firestore, orderBy, query, Query, where } from 'firebase/firestore'

export const getPracticeAdminsQuery = (db: Firestore, practiceId: string) =>
  query(
    collection(db, getPracticeUsersCollectionPath(practiceId)),
    where('role', 'in', practiceAdminRoles),
  ) as Query<PracticeUserRoleItem>

export const getPracticeInvoicesQuery = (db: Firestore, practiceId: string) =>
  query(collection(db, INVOICES), where('practiceId', '==', practiceId)) as Query<PracticeInvoice>

// §6.1: Returns all encounters for a practice ordered oldest-first by date.
// Used by the billing team dashboard to build the pending review queue.
// Requires a Firestore composite index on (practiceId ASC, date ASC).
export const getPracticeEncountersQuery = (db: Firestore, practiceId: string) =>
  query(
    collection(db, ENCOUNTERS),
    where('practiceId', '==', practiceId),
    orderBy('date', 'asc'),
  ) as Query<Encounter>

export const getPracticeMonthInvoicesQuery = (
  db: Firestore,
  practiceId: string,
  year: number,
  month: number,
) =>
  query(
    collection(db, INVOICES),
    where('practiceId', '==', practiceId),
    where('scheduledForShort', '==', `${year}-${month}-01`),
  ) as Query<PracticeInvoice>
